import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import 'animate.css'

import ElementUI from 'element-ui';
import 'element-theme-chalk/src/index.scss';//element-ui自定义主题
//import 'element-ui/lib/theme-chalk/index.css';//element-ui默认主题
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
